import isDesktop from '@/scripts/utilities/isDesktop';

document.addEventListener('DOMContentLoaded', function () {
  [...document.querySelectorAll('.card')].forEach((card) => {
    card.addEventListener('mouseenter', () => expandCard(card));
    card.addEventListener('focusin', () => expandCard(card));

    card.addEventListener('mouseleave', () => collapseCard(card));
    card.addEventListener('focusout', () => collapseCard(card));
  });
});

/**
 * @param {HTMLElement} card
 */
function expandCard(card) {
  if (!isDesktop()) return;
  card.classList.add('card--expanded');
  const content = card.querySelector('.card__expanded-content');
  content.style.height = content.scrollHeight + 'px';
}

/**
 * @param {HTMLElement} card
 */
function collapseCard(card) {
  if (!isDesktop()) return;
  card.classList.remove('card--expanded');
  const content = card.querySelector('.card__expanded-content');
  content.style.height = 0;
}
